
import { getPageCategory } from "@/utils/track"
import storage from "@/utils/storage"
export default {
  name: "GTM",
  mounted() {
    this.sendData()
  },
  methods: {
    sendData() {
      const { commonReqParams } = this.$commonParams
      const accountInfo = storage.get("accountInfo", { useBase64: true }) || null
      if (this.$gtm) {
        this.$gtm.push({
          event: "page_view",
          page_title: document.title,
          page_category: getPageCategory(),
          page_url: window.location.href,
          language: commonReqParams["superweb-locale"],
          user_id: accountInfo?.custId,
          login_status: accountInfo ? "Logged-in" : "Unlogged-in"
        })
      }
    }
  }
}
